import type { ChartDataPoint } from "@roman/shared/features/chart/types";
import { useMemo } from "react";
import { Line } from "recharts";
import { AnimatedDot, type AnimatedDotProps } from "../components/AnimatedDot";
import type { ChartConfig } from "../ui/chart";

type UseChartLinesProps = {
  selectedChoices: Array<{ id: string; name: string }>;
  chartConfig: ChartConfig;
  chartData: ChartDataPoint[];
  isActiveDotShown: boolean;
};

/**
 * Chart内のLineコンポーネントを生成するカスタムフック
 * Rechartsの制約により、Lineコンポーネントは直接返す必要があります
 */
export const useChartLines = ({ selectedChoices, chartConfig, chartData, isActiveDotShown }: UseChartLinesProps) => {
  return useMemo(() => {
    return selectedChoices.map((choice) => {
      const config = chartConfig[choice.id];
      const lineColor = config?.color || config?.theme?.light || "#000000";

      return (
        <Line
          key={choice.id}
          type="monotone"
          dataKey={choice.id}
          stroke={lineColor}
          strokeWidth={2}
          animationEasing="ease"
          animationDuration={500}
          dot={(props) => {
            // Latest Dot
            if (props.index === chartData.length - 1 && !isActiveDotShown) {
              return <AnimatedDot {...props} color={lineColor} />;
            }
            return <></>;
          }}
          activeDot={(props: AnimatedDotProps) => {
            if (!isActiveDotShown) {
              return <></>;
            }
            return <AnimatedDot {...props} color={lineColor} />;
          }}
        />
      );
    });
  }, [selectedChoices, chartConfig, chartData, isActiveDotShown]);
};
